import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ColumnMode } from "@swimlane/ngx-datatable";
import { ToastrService } from 'ngx-toastr';
import { FinanceService } from '../../../../shared/services/admServices/finance.service';
import { PaymentsConfig } from '../../../../models/admModel/finance.model';
import { Page, PageClass } from '../../../../shared/filters/filters';

declare var require
const Swal = require('sweetalert2')


@Component({
  selector: 'adm-payments-component',
  templateUrl: './payments-component.html',
  styleUrls: ['./payments-component.scss']
})

export class finpaymentsComponent implements OnInit {
  currentDate = new Date();
  currentPayments: any;
  allPayments: any;

  pendingConversions: number;
  totalProfit: any;
  totalRevenue: number;
  totalToPaidToday: number;

  PaymentsConfig = new PaymentsConfig();
  nextpayDayDate: any;
  dayNumber: number;

  sendpage = new PageClass();
  sendpageAll = new PageClass();
  page = new Page();
  pageAll = new Page();

  pageSizeDefinition = 6;
  pageSizeDefinitionAll = 20;
  active = 'payments';
  ColumnMode = ColumnMode;

  constructor(private router: Router, private toastrService: ToastrService, private financeService: FinanceService) {
    
    this.page.pageNumber = 1;
    this.page.size = this.pageSizeDefinition;

    this.pageAll.pageNumber = 1;
    this.pageAll.size = this.pageSizeDefinitionAll;
  }

  ngOnInit(): void {
    this.getConfig();
    this.getSummary();
    this.setPage({  offset: 0 });
    this.setPageAll({  offset: 0 });
  }

  getConfig(){
    // API pobrania konfiguracji payments
    this.financeService.getConfig()
    .subscribe(
      data => {
        this.PaymentsConfig.feePayoneer = data.data.feePayoneer;
        this.PaymentsConfig.feePaypal = data.data.feePaypal;
        this.PaymentsConfig.feeWired = data.data.feeWired;
        this.PaymentsConfig.payday = data.data.payday;
        this.dayNumber = this.day2number(this.PaymentsConfig.payday);
        this.PaymentsConfig.minAmount = data.data.minAmount;

        if(this.dayNumber==this.currentDate.getDay()+1)
          this.nextpayDayDate="Tomorrow";
        else
        {
          if(this.dayNumber==this.currentDate.getDay())
            this.nextpayDayDate="Today";
          else
            this.nextpayDayDate = this.getnextpaydayDate(this.dayNumber);
        }

    },
    error => {
      console.log(error);
    });
   }

  getSummary(){
    this.financeService.getFinanceSymmary()
    .subscribe(
      data => {
          this.totalProfit = this.roundTo(data.data.totalProfit, 2);//parseFloat(Math.round(data.data.totalProfit*10^2)/10^2);
          this.pendingConversions = this.roundTo(data.data.pendingConversions, 2);
          this.totalRevenue = this.roundTo(data.data.totalRevenue, 2);
          this.totalToPaidToday = this.roundTo(data.data.totalToPaidToday, 2);
    },
    error => {
      console.log(error);
    });
   }

  setPage(pageInfo){
    this.sendpage.pageNumber = pageInfo.offset+1;
    this.sendpage.pageSize = this.pageSizeDefinition;

    this.financeService.getPaymentsToday(this.sendpage)
    .subscribe(
      data => {
      this.page.totalElements = data.totalRecords;
      this.page.totalPages = data.totalPages;
      this.page.pageNumber = data.pageNumber-1;

      this.currentPayments = data.data;
      },
      error => {
        console.log(error);
      });

  }

  setPageAll(pageInfoAll){
    this.sendpageAll.pageNumber = pageInfoAll.offset+1;
    this.sendpageAll.pageSize = this.pageSizeDefinitionAll;

    this.financeService.getPaymentsAll(this.sendpageAll)
    .subscribe(
      data => {
      this.pageAll.totalElements = data.totalRecords;
      this.pageAll.totalPages = data.totalPages;
      this.pageAll.pageNumber = data.pageNumber-1;

      this.allPayments = data.data;
      },
      error => {
        console.log(error);
      });

  }

  onPaid(req) {
    this.router.navigate(['/adm/payments/'+ req.id]);
  }

  onSave(){
    this.financeService.setConfig(this.PaymentsConfig)
    .subscribe(
      response => {
         this.toastrService.success('Configuration saved.', 'Success !');
            this.dayNumber = this.day2number(this.PaymentsConfig.payday);
            if(this.dayNumber==this.currentDate.getDay()+1)
            this.nextpayDayDate="Tomorrow";
            else
            {
              if(this.dayNumber==this.currentDate.getDay())
                this.nextpayDayDate="Today";
              else
                this.nextpayDayDate = this.getnextpaydayDate(this.dayNumber);
            }
      },
      error => {
        console.log(error);
      });

  }

  getnextpaydayDate(day: number) {
    const now = new Date()
    const today = new Date(now)
    today.setMilliseconds(0)
    today.setSeconds(0)
    today.setMinutes(0)
    today.setHours(0)

    const nextPay = new Date(today)

    do {
      nextPay.setDate(nextPay.getDate() + 1) // Adding 1 day
    } while (nextPay.getDay() !== day) //0-sun 1-mon 2-tue 3-wed

    return nextPay
  }

  day2number(day: any): number{
    switch(day){
      case "Monday":
        return 1;
        break;

      case "Tuesday":
        return 2;
        break;

      case "Wednesday":
        return 3;
        break;

      case "Thursday":
        return 4;
        break;

      case "Friday":
        return 5;
        break;

      case "Saturday":
        return 6;
        break;

      case "Sunday":
        return 0;
        break;
    }
    return 0;
  }

  roundTo(num: number, places: number) {
    const factor = 10 ** places;
    return Math.round(num * factor) / factor;
  }
}
